(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('Invitation', Invitation)

    Invitation.$inject = ['$resource'];

    function Invitation($resource) {
        var resourceUrl = 'api/invitations/:id';

        return $resource(resourceUrl, {}, {
            'create': {method: 'POST'},
            'invitationList': {method: 'GET', url: "api/invitations-list", isArray: true},
            'sendMail': {method: 'PUT', url: "api/invitations-email"},
            'delete': {method: 'DELETE'}
        });
    }
})();
